import {
    FETCH_ADD_PROJECT_TEMPLATE_AUTO_TASK_REQUEST,
    FETCH_ADD_PROJECT_TEMPLATE_AUTO_TASK_SUCCESS,
    FETCH_ADD_PROJECT_TEMPLATE_AUTO_TASK_FALUIRE,
} from './addProjectTemplateAutoTaskTypes'

const initialState = {
  loading: false,
  addProjectTemplateAutoTask: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_ADD_PROJECT_TEMPLATE_AUTO_TASK_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_ADD_PROJECT_TEMPLATE_AUTO_TASK_SUCCESS : return {
      ...state,
      addProjectTemplateAutoTask: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_ADD_PROJECT_TEMPLATE_AUTO_TASK_FALUIRE : return {
      ...state,
      loading: false,
      addProjectTemplateAutoTask: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
